/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminsubs_Ledgerloadmore3Inputs */

const zh_adminsubs_ledgerloadmore3 = /** @type {(inputs: Adminsubs_Ledgerloadmore3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加载更多记录`)
};

const en_adminsubs_ledgerloadmore3 = /** @type {(inputs: Adminsubs_Ledgerloadmore3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more records`)
};

const es_adminsubs_ledgerloadmore3 = /** @type {(inputs: Adminsubs_Ledgerloadmore3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargar más registros`)
};

/**
* | output |
* | --- |
* | "Load more records" |
*
* @param {Adminsubs_Ledgerloadmore3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminsubs_ledgerloadmore3 = /** @type {((inputs?: Adminsubs_Ledgerloadmore3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminsubs_Ledgerloadmore3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminsubs_ledgerloadmore3(inputs)
	if (locale === "en") return en_adminsubs_ledgerloadmore3(inputs)
	return es_adminsubs_ledgerloadmore3(inputs)
});
export { adminsubs_ledgerloadmore3 as "adminSubs_ledgerLoadMore" }